import { render, staticRenderFns } from "./fixedPrice.vue?vue&type=template&id=2ba70393&scoped=true"
import script from "./fixedPrice.vue?vue&type=script&lang=ts"
export * from "./fixedPrice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba70393",
  null
  
)

export default component.exports